export default {"src":"/_next/static/media/REF_FINANCE.19a4f744.svg","height":23,"width":132,"blurWidth":0,"blurHeight":0};